export enum MedicationType {
  ORAL_HYPOGLYCEMIC = 0,
  INSULIN = 1,
  NONE = 2,
}
